import {
  createTransferReservationBaseInitialValues,
  createTrasferReservationBaseLocationInitialValues
} from '../../../viajeTraslado/forms/base/TransferReservationBaseFormInitialValues';
import { ViajeTrasladoTipoServicio } from '../../models';
import {
  TransferReservationBatchFormType,
  TransferReservationBatchLocationFormType,
  TransferReservationBatchTripFormType
} from './TransferReservationBatchFormType';
import moment from 'moment';

export const createTransferReservationBatchLocationInitialValues: () => TransferReservationBatchLocationFormType =
  createTrasferReservationBaseLocationInitialValues;

export const createTransferReservationBatchTripInitialValues =
  (): TransferReservationBatchTripFormType => ({
    prioridad: false,
    hasOutSite: false,
    fixedRate: null,
    tipoServicio: ViajeTrasladoTipoServicio.EJECUTIVO,
    bus_provider_price: 0,
    bus_customer_price: 0,
    bus_is_outsourced: false,
    bus_observation: '',
    bus_type_id: 0,
    bus_vehicle_id: 0,
    fechaYHoraDeLlegada: moment(),
    minutosPreviosASalida: moment(),
    puntos: []
  });

export const createTransferReservationBatchInitialValues =
  (): TransferReservationBatchFormType => ({
    ...createTransferReservationBaseInitialValues(),
    viajes: [createTransferReservationBatchTripInitialValues()]
  });
